export default __webpack_public_path__ + "static/media/graduated-purple.e31d147d.svg";